var _defs, _path, _path2, _circle, _path3, _use, _use2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 600,
    viewBox: "-50 -30 100 60",
    fill: "#ce1126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-50-30H50v60H-50z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-50-30H50v60H-50z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1eb53a",
    strokeWidth: 8,
    stroke: "#fff",
    clipPath: "url(#a)",
    d: "M-60-36v72L60-36v72z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    r: 17
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1eb53a",
    strokeWidth: 0.36,
    id: "b",
    d: "M1.05-10.62h2.1L2.1-8.8l1.05 1.82h-2.1L0-5.16l-1.05-1.82h-2.1L-2.1-8.8l-1.05-1.82h2.1L0-12.44z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    x: -7.62,
    y: 13.2,
    xlinkHref: "#b"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    x: 7.62,
    y: 13.2,
    xlinkHref: "#b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBi);
export default __webpack_public_path__ + "static/media/bi.991d51a683e3ef02ce734feea851fd9c.svg";
export { ForwardRef as ReactComponent };